
define('text!templates/modules/setting/personal/blocks/custom-messages/list/custom-messages-list-item.html',[],function () { return '<div class="item-section"></div>\n<div class="sub-section box"></div>\n';});

